import React from "react";
import { callApi } from "../../utils/api";
import { Deed } from "./ManageDeed";
import { ToastsStore } from "react-toasts";

declare var $: any;
interface AllProps {
  selectedDeed: Deed;
  listDeed: any;
}
class AddDeed extends React.Component<AllProps> {
  state = {
    deeddetail: {
      id: 0,
      deed: "",
    },
    users: [],
    isLoading: false
  };
  componentWillReceiveProps(nextState) {
    const deeddetail = nextState.selectedDeed;
    deeddetail.deed = deeddetail.name;
    this.setState({ deeddetail });
  }
  handleChange = (e: any) => {
    const deeddetail: any = this.state.deeddetail;
    deeddetail[e.target.name] = e.target.value;
    this.setState({ deeddetail });
  };
  handleSaveResponse = (response: any) => {
    if (
      response.result === false ||
      (response.message && response.message.indexOf("Already Exist") !== -1)
    ) {
      ToastsStore.error(response.message || "Failed to save deed");
      return;
    }
    this.props.listDeed();
    $("#deed-form").modal("hide");
    ToastsStore.success(response.message || "Deed saved successfully");
  };
  saveDeed = () => {
    const deeddetail = { ...this.state.deeddetail };
    deeddetail.deed = deeddetail.deed ? deeddetail.deed.trim() : "";
    if (!deeddetail.deed) {
      ToastsStore.error("Deed name is required");
      return;
    }
    if (deeddetail.id) {
      deeddetail.id = Number(deeddetail.id);
    }
    this.setState({ isLoading: true, deeddetail });
    callApi("POST", "deed_master.php", deeddetail)
      .then(res => res.data)
      .then(response => {
        this.handleSaveResponse(response);
      })
      .catch(err => {
        console.log(err);
        ToastsStore.error("Something went wrong, please try again");
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  };
  render() {
    return (
      <div
        className="modal fade"
        id="deed-form"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Deed Form</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="form-group">
                  <label className="col-form-label">Deed Name</label>
                  <input
                    type="text"
                    name="deed"
                    className="form-control"
                    placeholder="Deed Name"
                    onChange={e => {
                      this.handleChange(e);
                    }}
                    value={
                      this.state.deeddetail.deed
                        ? this.state.deeddetail.deed
                        : ""
                    }
                  />
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                disabled={this.state.isLoading}
                onClick={this.saveDeed}
              >
                {this.state.isLoading ? (
                  <i className="fa fa-spinner fa-spin" aria-hidden="true" />
                ) : (
                  "Save"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default AddDeed;
